import { render } from "./DataItem.vue?vue&type=template&id=529761cd"
import script from "./DataItem.vue?vue&type=script&lang=js"
export * from "./DataItem.vue?vue&type=script&lang=js"

import "./DataItem.vue?vue&type=style&index=0&id=529761cd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__